<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.7273 108.74C25.0185 108.74 21.1551 104.887 21.1551 100.168V88.5882C21.1551 83.8793 25.0185 80.016 29.7273 80.016C34.4361 80.016 38.2995 83.8793 38.2995 88.5882V100.168C38.2995 104.887 34.4361 108.74 29.7273 108.74Z"
      fill="#CB80DE"
    />
    <path
      d="M98.3155 108.74C93.6067 108.74 89.7433 104.887 89.7433 100.168V88.5883C89.7433 83.8794 93.6067 80.0161 98.3155 80.0161C103.024 80.0161 106.888 83.8794 106.888 88.5883V100.168C106.888 104.887 103.024 108.74 98.3155 108.74Z"
      fill="#CB80DE"
    />
    <path
      d="M50.7457 20C35.0568 20 22.2146 32.8315 22.2146 48.5312C22.2146 64.2308 35.0568 77.0623 50.7457 77.0623H77.6716C93.3606 77.0623 106.203 64.2201 106.203 48.5312C106.203 32.8422 93.3606 20 77.6716 20H50.7457Z"
      fill="#CB80DE"
    />
    <path
      d="M21.8079 54.9096C12.0157 54.9096 4 62.9146 4 72.7175C4 82.5204 12.0157 90.5254 21.8079 90.5254H106.192C115.856 90.5254 123.797 82.7238 124 73.1028V72.3323C123.797 62.7113 115.856 54.9096 106.192 54.9096H21.8079Z"
    />
    <path
      d="M21.8507 78.0575H16.9065C13.9741 78.0575 11.5662 75.6496 11.5662 72.7173C11.5662 69.785 13.9741 67.377 16.9065 67.377H21.8507C24.7937 67.377 27.1909 69.7743 27.1909 72.7173C27.1909 75.6603 24.7937 78.0575 21.8507 78.0575Z"
      fill="#CB80DE"
    />
    <path
      d="M111.104 78.0576H106.16C103.228 78.0576 100.82 75.6497 100.82 72.7174C100.82 69.7851 103.228 67.3771 106.16 67.3771H111.104C114.047 67.3771 116.444 69.7744 116.444 72.7174C116.444 75.6604 114.047 78.0576 111.104 78.0576Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'CarLoan'
  }
</script>
